<template>
  <div class="mt-14 box_pay" :show="qrcodeLoading" :class="{ 'mt-20': qrcodeLoading }">
    <div
      class="mt-4"
      v-if="iscode.codeImg === '' ? true : false"
      style="text-align: center; color: #d1d5db"
      >请到发票管理查看</div
    >
    <div v-if="iscode.codeImg === '' ? false : true">
      <div class="box_ercode">
        <img class="box_codeImg" :src="imgBaseUrl + iscode.codeImg" />
      </div>
      <div class="box_tishi">职业技能培训学员无需缴费</div>
    </div>
  </div>
</template>

<script setup>
import { ispay } from '@/api';
import { ref, reactive, onMounted, onUpdated, onUnmounted } from 'vue';
const imgBaseUrl = 'https://qingjuck.oss-cn-shanghai.aliyuncs.com/';
const qrcodeLoading = ref(true);
const iscode = reactive({
  codeImg: '',
});
// 加载完毕
onMounted(() => {
  console.log('缴费加载完毕');
  ispay({ step: 0 }).then(res => {
    console.log(res);
    if (res.success === true) {
      if (res.data.ispay === 'N') {
        iscode.codeImg = res.data.qrcode_url;
        console.log(iscode.codeImg);
      }
    } else {
      window.message.error('缴费异常');
    }
  });
});
</script>

<style lang="scss" scoped>
.box_pay {
  height: 500px;
  border: 1px solid #d1d5db;

  .box_ercode {
    width: 230px;
    height: 230px;
    margin: 20px auto;
    border: 1px solid #d1d5db;
    background-color: #faf9f9;
    .box_codeImg {
      width: 200px;
      height: 200px;
      margin: 12px 12px;
    }
  }

  .box_tishi {
    text-align: center;
  }
}
</style>
